<mat-icon class="mat-icon-rtl-mirror" class="small">{{'error'}}</mat-icon>
<div class="message">{{"GDPR FREE FIELD MESSAGE" | translate}}</div>
